export * from './dict'

export const ROUTER_ID = 'router-container'

// 滚动的默认设置
export const ScrollOptions = {
  container: '#router-container', //滚动的容器
  duration: 300, //滚动时间
  easing: 'ease', //缓动类型
  offset: -8, // 滚动时应应用的偏移量。此选项接受回调函数
  force: true, // 是否应执行滚动
  cancelable: true, // 用户是否可以取消滚动
  onStart: false, // 滚动开始时的钩子函数
  onDone: false, // 滚动结束时候的钩子函数
  onCancel: false, // 用户取消滚动的钩子函数
  x: false, // 是否要在x轴上也滚动
  y: true, // 是否要在y轴上滚动
}

export const API_TIMEOUT = 0 // 不限时间

export const PLATFORMS_KEY = 'platforms' // 平台

export const USERNAME_KEY = 'username' // 用户名

export const ROUTES_KEY = 'routes' // 路由

export const ROUTES_MAP_KEY = 'routesMap' // 路由map

export const IS_MENU_FOLD = 'isMenuFold' // 菜单是否折叠
